import React, { Component } from "react";
import MultiSelectDropdown from "./MultiSelectDropdown";
import "./BulkCommand.css";
import list from '../../assets/images/icon/list.png'
import CommandAPIs from '../../APIs/CommandAPIs'
import moment from "moment";

class BulkCommand extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedVehicles: [],
      showDropdown: false,
      csvFileName: "Upload CSV",
      csvDisabled: false,
      multiSelectDisabled: false,
      command: "",
      searchQuery: "",
      fillAllfield: false,
      bulkExecute: false,
    };
  }

  handleVehicleSelect = (vehicles) => {
    this.setState({
      selectedVehicles: vehicles,
      showDropdown: false,
      csvDisabled: true,
    });
  };

  handleFileUpload = (event) => {
    const file = event.target.files[0];
  
    if (file && file.type === "text/csv") {
      const reader = new FileReader();
  
      reader.onload = (e) => {
        const text = e.target.result;
        const rows = text.split("\n")
          .map((row, index) => ({
            vehicleno: row.replace("\r", "").trim(),
            id: index
          }))
          .filter(item => item.vehicleno !== ""); 
        this.setState({
          csvFileName: file.name,
          multiSelectDisabled: true,
          selectedVehicles: rows,
        });
      };
  
      reader.readAsText(file);
    }
  };
  
  handleRemoveVehicle = (id) => {
    this.setState((prevState) => ({
      selectedVehicles: prevState.selectedVehicles.filter(
        (v) => v.id !== id
      ),
    }));
  };
  clearAll = () => {
    this.setState({
      selectedVehicles: [],
      csvDisabled:false,
      multiSelectDisabled:false,
    })
  }

  handleCommandChange = (event) => {
    this.setState({ command: event.target.value });
  };

  handleCommandType = (event) => {
    this.setState({type:event.target.value})
  }

  executeBulk = () => {
    let {selectedVehicles,command, type} = this.state
    if(selectedVehicles.length && command !== '' && type !== undefined){
        this.setState({bulkExecute: true})
    }else {
      this.setState({fillAllfield: true, errorMsg: "Please select a command, type and vehicles to execute the bulk action"})
    }
    
  }

  cancelExecuteCommand = () => {
    this.setState({bulkExecute:false})
  }

  executeCommand = () => {
    
    let {selectedVehicles,command, type} = this.state
    let body = {
      vehicles: selectedVehicles.map((veh) => {return veh.vehicleno}),
      type: type
    }

    switch (command) {
      case "immobilize":
        CommandAPIs.bulkImmobilize(body).then((resp) =>{
          setTimeout(() => {
            let startDate = moment(Date.now()).startOf("day").subtract(1, "days")
            let endDate= moment()
            this.props.fetchHistory(startDate,endDate)
            
          }, 2000);
        }).catch(() => {
          console.log("command execution failed")
        })
        
        break;
      case "mobilize":
        CommandAPIs.bulkMobilize(body).then((resp) =>{
          setTimeout(() => {
            let startDate = moment(Date.now()).startOf("day").subtract(1, "days")
            let endDate= moment()
            this.props.fetchHistory(startDate,endDate)
              
            }, 2000);
        }).catch(() => {
          console.log("command execution failed")
        })
      
      break;  
    
      default:
        break;
    }
    this.setState({ selectedVehicles: [],
      showDropdown: false,
      csvFileName: "Upload CSV",
      csvDisabled: false,
      multiSelectDisabled: false,
      command: "",
      searchQuery: "",
      fillAllfield: false,
      bulkExecute: false,})
  }
  cancelErrorBox = () => {
    this.setState({fillAllfield: false})
  }

  handleSearch = (query) => {
    this.setState({ searchQuery: query });
  };

  toggleDropdown = () => {
    this.setState((prevState) => ({ showDropdown: true}));
  };

  render() {
    const { selectedVehicles, showDropdown, csvFileName, csvDisabled, multiSelectDisabled, command, searchQuery,type } = this.state;
    const { vehicleList } = this.props;

    return (
      <div className="bulk-command">
        <div className="top-container">
            <h2>Bulk Command</h2>

            <div className="top-section">
            <input
                type="text"
                className="search-bar"
                placeholder="Select Vehicles"
                value={searchQuery}
                onClick={this.toggleDropdown}
                onChange={(e) => this.handleSearch(e.target.value)}
            />
            <label className="csv-upload">
                <input
                type="file"
                accept=".csv"
                disabled={csvDisabled}
                onChange={this.handleFileUpload}
                />
                {csvFileName}
            </label>
            </div>

            {showDropdown && (
            <MultiSelectDropdown
                vehicleList={vehicleList}
                onSelect={this.handleVehicleSelect}
                onClose={() => this.setState({ showDropdown: false })}
                selectedVehicles={selectedVehicles}
                searchQuery={searchQuery}
            />
            )}

            <div className="selected-vehicles-container">
                {selectedVehicles && selectedVehicles.length ? <div className="selected-numbers">
                  <span className="numbers">Selected Vehicles ({selectedVehicles.length})</span>
                  <span className="clearall" onClick={() => this.clearAll()}>Clear all</span> 
                </div>: null}
            <div className="selected-vehicles">
                {selectedVehicles.map((vehicle) => (
                <span key={vehicle.id} className="vehicle-tag">
                    {vehicle.vehicleno}
                    <button className="close-btn" onClick={() => this.handleRemoveVehicle(vehicle.id)}>X</button>
                </span>
                ))}
            </div>
            </div>




            <div className="command-section">
              <select value={command} onChange={this.handleCommandChange}>
                  <option value="">Select Command</option>
                  <option value="immobilize">Immobilize</option>
                  <option value="mobilize">Mobilize</option>
              </select>
              <select value={type} onChange={this.handleCommandType}>
                  <option  value="">Select Type</option>
                  <option value="ignition">Ignition</option>
                  <option value="crank">Crank</option>
                  <option value="can">CAN</option>
                  <option value="charge">Charge</option>
                  <option value="discharge">Discharge</option>
                  <option value="chargendischarge">Chargendischarge</option>
              </select>
            </div>
        </div>
        

        <div className="action-buttons">
          <button className="cancel-btn" onClick={() => this.props.bulkClose()}>Cancel</button>
          <button className="execute-btn" onClick={() => this.executeBulk()}>Execute</button>
        </div>
        {this.state.fillAllfield && <div className="execute-error-container">
          <div className="execute-error">
            <div className="error-box">
              <span>{this.state.errorMsg}</span>
            </div>
                <span className="error-close"><button onClick={() => {this.cancelErrorBox()}}>Close</button></span>
          </div>
            

          </div>}
          {this.state.bulkExecute && <div className="execute-bulk-container">
            <div className="execute-bulk">
              <div className="execute-box">
                <span className="list-icon"><img src={list} /></span>
                <div className="execute-msg">
                  <span>Are you sure you want to <span>{this.state.command}</span> <span>{this.state.selectedVehicles.length}</span> vehicles?</span>
                </div>  
              </div>
              <div className="execute-action">
                <button className="execute-cancel" onClick={() => {this.cancelExecuteCommand()}}>Cancel</button>
                <button className="execute-ok" onClick={() => {this.executeCommand()}}>OK</button>
              </div>
            </div>
            
          </div>}
      </div>
    );
  }
}

export default BulkCommand;
